export default __webpack_public_path__ + "static/media/more_scrolled.d8cb7ff0.svg";